import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location  } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { decryptPledgeData } from 'src/app/shared/crypto-js/crypto-js';
@Injectable({
  providedIn: 'root'
})
export class ClevertapService {

  clientId: any;

  constructor(
    private location: Location,
    private cookies: CookieService,
    private http: HttpClient

    ) { 

    const encryptedUserSession = localStorage.getItem('encryptedUserSession');

    if (encryptedUserSession) {
      const decryptedStr = decryptPledgeData(encryptedUserSession);
      const decryptedData = JSON.parse(decryptedStr);
      this.clientId = decryptedData.accountId;
    }
  }

  pushClevertap(params:any):Observable<any>{
    return this.http.get(`/userTrack`,{params})
    // /userTrack
  }


  // pushClevertap(params: HttpParams) {
    // const currentPath = this.location.path();
    // const fullUrl = window.location.origin + currentPath;
    // const currentUrl = fullUrl;
  
    // const clientId = this.clientId;
  
    // // const clevertap_id = 'W44-9RW-WW7Z'; // uat
    // const clevertap_id = 'W44-9RW-WW7Z'; // Prod
  
    // window['clevertap'] = { event: [], profile: [], account: [], onUserLogin: [], region: 'in1', notifications: [], privacy: [] };
  
    // if (clevertap_id) {
    //   window['clevertap'].account.push({ "id": clevertap_id });
    // }
  
    // window['clevertap'].privacy.push({ optOut: false });
    // window['clevertap'].privacy.push({ useIP: true });
  
    // window['clevertap'].enablePersonalization = true;
    // window['clevertap'].spa = true;
  
    // (function () {
    //   var wzrk = document.createElement('script');
    //   wzrk.type = 'text/javascript';
    //   wzrk.async = true;
    //   wzrk.src = ('https:' == document.location.protocol ? 'https://d2r1yp2w7bby2u.cloudfront.net' : 'http://static.clevertap.com') + '/js/clevertap.min.js';
    //   wzrk.onload = function () {
    //     const eventParams = {
    //       'page_url': currentUrl,
    //       'time': new Date().getTime(),
    //     };
  
    //     params.keys().forEach(key => {
    //       eventParams[key] = params.get(key);
    //     });
  
    //     window['clevertap'].profile.push({
    //       "Site": {
    //         'identity': clientId
    //       }
    //     });

    //     // console.log(eventParams);
    //     var data = "";
    //     if(params.get('data')){
    //       data = ' - ' + params.get('data');
    //     }
        
  
    //     window['clevertap'].event.push("BOT - " + params.get('page') + " - " + params.get('event_name') + data, eventParams);
    //   };
    //   var s = document.getElementsByTagName('script')[0];
    //   s.parentNode.insertBefore(wzrk, s);
    // })();
    
  // }

}
